import { Tag, TagProps } from 'antd';
import { useMemo } from 'react';

const TAG_STYLES = {
  red: { color: '#D7382D', background: '#FFEDEC' },
  orange: { color: '#E88B00', background: '#FFF6E9' },
  yellow: { color: '#CC9900', background: '#FFFAE6' },
  green: { color: '#2A7106', background: '#EBF3E8' },
  green_solid: { color: '#FBFBFB', background: '#339900' },
  blue: { color: '#0958D9', background: '#E5F2FF' },
  blue_solid: { color: '#FBFBFB', background: '#056DF5' },
  grey: { color: '#545454', background: '#E7E7E7' },
  default: { color: '#545454', background: '#D6D6D6' },
};

type TagStyleKey = keyof typeof TAG_STYLES;

const STATUS_TO_TYPE_MAP: Record<string, TagStyleKey> = {
  harvested: 'green_solid',
  upcoming: 'grey',
  blocked: 'grey',
  active: 'blue',
  delivered: 'blue',
  /* green */
  completed: 'green',
  serviced: 'green',
  verified: 'green',
  installed: 'green',
  settled: 'green',
  approved: 'green',
  paid: 'green',
  /* orange */
  overdue: 'orange',
  pending: 'orange',
  live: 'orange',
  partial: 'orange',
  /* yellow */
  'in review': 'yellow',
  in_review: 'yellow',
  'not serviced': 'yellow',
  shipping: 'yellow',
  /* red */
  late: 'red',
  failed: 'red',
  rejected: 'red',
  unverified: 'red',
  incomplete: 'red',
};

type StatusBasedProps = {
  status: string;
  text?: string;
  type?: never;
};

type ManualProps = {
  type: TagStyleKey;
  text: string;
  status?: never;
};

type PipeStatusTagProps = TagProps & (StatusBasedProps | ManualProps);

const StatusTag = (props: PipeStatusTagProps) => {
  const { status, text, type, style, ...restProps } = props;
  const { tagType, tagText } = useMemo(() => {
    if ('status' in props && status) {
      const lowerCaseStatus = status.toLowerCase();
      const finalType = STATUS_TO_TYPE_MAP[lowerCaseStatus] ?? 'default';
      const finalText = text ?? lowerCaseStatus.replace(/_/g, ' ');
      return { tagType: finalType, tagText: finalText };
    }

    if ('type' in props && type) {
      return { tagType: type, tagText: text };
    }

    return { tagType: 'default' as TagStyleKey, tagText: '' };
  }, [props]);

  const finalTagStyle = TAG_STYLES[tagType];
  return (
    <Tag
      className="tag"
      style={{
        ...style,
        ...finalTagStyle,
        textTransform: 'capitalize',
      }}
      {...restProps}
    >
      {tagText.toLowerCase()}
    </Tag>
  );
};
export default StatusTag;
